import React from "react";
import styled from "@emotion/styled";

function Header({ monthName }) {
  return (
    <Container>
      <Month>
        <b>{monthName}</b> 2019
      </Month>
    </Container>
  );
}

export default Header;

const Container = styled.div`
  height: 100%;
  box-sizing: border-box;
  padding: 0 1em;
  display: flex;
  align-items: center;
`;

const Month = styled.h1`
  font-weight: normal;
  b {
    color: turquoise;
  }
`;
